/**
 * Twin recall resource — the units reachable from a lot (the recall roll-up that
 * RecallPanel renders on the Parts page).
 *
 * The rest of the old v1 capture client (start-heat / tap / pour / qc /
 * serialize / close + the marker-resolve helper + their React Query hooks) was
 * removed together with the v1 Capture UI: ingress is now the v2 data-source
 * pipeline (readings → capture-worker). The /v1/twin/recall, /markers/resolve,
 * and /capture/* endpoints still exist server-side (scanner / app sources); the
 * frontend just no longer drives capture mutations from a screen.
 */

import { api } from "@/lib/api-client";
import { qs } from "./qs";

/** One unit reachable from a lot (recall roll-up row). */
export interface RecallUnit {
  id: string;
  cavity_no?: number;
  status: string;
  [key: string]: unknown;
}

export interface RecallResult {
  lot: string;
  units: RecallUnit[];
  total: number;
  truncated: boolean;
}

export const twinCapture = {
  /** Units reachable from a lot (recall). */
  recall: (lot: string) => api.get<RecallResult>(`/v1/twin/recall${qs({ lot })}`),
};
